var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectGenericV02Linked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4,20H4c-1.1,0-2-0.9-2-2L2,6c0-1.1,0.9-2,2-2h6l2,2h8c1.1,0,2,0.9,2,2v5h-6v-3h-2v3c-0.3,0-0.7,0-1,0.1V9.6 c0-1.2-0.7-2.3-1.9-2.5C9.5,6.7,8,7.9,8,9.5v4.4C8,15,8.4,16,9.2,16.8C9.1,17.2,9,17.6,9,18C9,18.7,9.2,19.4,9.4,20z M11,14L11,14 l0-4.5C11,9.2,10.8,9,10.5,9S10,9.2,10,9.5V14c0,0.3,0.1,0.6,0.2,0.8C10.4,14.5,10.7,14.2,11,14z M14,20h2v2h-2c-2.2,0-4-1.8-4-4 s1.8-4,4-4h2v2h-2c-1.1,0-2,0.9-2,2S12.9,20,14,20z M24,18c0,2.2-1.8,4-4,4h-2v-2h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2v-2h2 C22.2,14,24,15.8,24,18z M14,19h6v-2h-6V19z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectGenericV02Linked);
export default __webpack_public_path__ + "static/media/projectGeneric_v02_Linked.6e998c12488de5ec4eaeac13d56f9201.svg";
export { ForwardRef as ReactComponent };